import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LogoContrast from '../assets/logo-contrast.svg';
import TermsModal from '../components/TermsModal';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
`;

const FooterLogo = styled.img`
  width: 45%;
  max-width: 220px;
  height: auto;
  align-self: center;
  margin-top: 60px;
  cursor: pointer;
`;

const WrappedLink = styled(Link)`
  margin: 10px 0;

  @media (orientation: portrait) and (max-width: 767px) {
    margin: 12px 0;
  }
`;

const CustomLink = styled.a`
  color: ${({ theme }) => theme.colors.basic400};
  font-size: 18px;
  font-weight: 600;
  margin: 10px 0;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease-out;

  :hover {
    color: ${({ theme }) => theme.colors.background};
  }
`;

const InnerLink = styled.span`
  color: ${({ theme }) => theme.colors.basic400};
  font-size: 18px;
  font-weight: 600;
  margin: 10px 0;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease-out;

  :hover {
    color: ${({ theme }) => theme.colors.background};
  }
`;

const Footer = () => {
  const navigate = useNavigate();
  const [showTermsModal, setShowTermsModal] = useState(false);

  return (
    <Wrapper>
      <WrappedLink to="/nosotros" style={{ textDecoration: 'none' }}><InnerLink>Nosotros</InnerLink></WrappedLink>
      <WrappedLink to="/faq" style={{ textDecoration: 'none' }}><InnerLink>FAQ</InnerLink></WrappedLink>
      <InnerLink onClick={() => setShowTermsModal(true)}>Términos y condiciones</InnerLink>
      {/* <WrappedLink to="/" style={{ textDecoration: 'none' }}><InnerLink>Buscar ofertas</InnerLink></WrappedLink> */}
      <FooterLogo onClick={() => navigate('/')} src={LogoContrast} alt="Prestix" />
      
      <TermsModal 
        isOpen={showTermsModal} 
        onClose={() => setShowTermsModal(false)} 
      />
    </Wrapper>
  );
};

export default Footer;